"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "onChange", "label", "type"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Checkbox/index.js";
function noop() {}
var defaultProps = {
  onChange: noop,
  type: 'checkbox'
};
var Checkbox = /*#__PURE__*/_react["default"].forwardRef(function Checkbox(_ref, ref) {
  var className = _ref.className,
    onChange = _ref.onChange,
    label = _ref.label,
    type = _ref.type,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = (0, _classNames["default"])('form-check', className);
  var _onChange = function _onChange(event) {
    event.stopPropagation();
    onChange(event.target.checked);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("input", Object.assign({
    type: type,
    ref: ref,
    className: "form-check-input",
    onChange: _onChange
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 13
    }
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label",
    htmlFor: props.id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 13
    }
  }, label));
});
Checkbox.defaultProps = defaultProps;
var _default = Checkbox;
exports["default"] = _default;